import { gql, useQuery } from '@apollo/client';
import { Alert, AlertDescription, Center } from '@chakra-ui/react';
import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import styles from './App.module.scss';
import Footer from './Footer';
import Header from './Header';

const NEW_MOVIES_QUERY = gql`
  query NewMoviesQuery {
    newMovies {
      id
      poster_path
      title
    }
  }
`;

const Movies = () => {
  const { loading, error, data } = useQuery(NEW_MOVIES_QUERY);

  if (loading) return <div className={styles.loader}></div>;
  if (error)
    return (
      <Center>
        <Alert bg="#f9bf3b" color="#000" w={500}>
          <AlertDescription px={1} py={1}>
            An error occurred
          </AlertDescription>
        </Alert>
      </Center>
    );
  return (
    <Fragment>
      <Header />
      <div className={styles.movies}>
        {data.newMovies.map(movie => (
          <div className={styles.movie} key={movie.id}>
            <div className={styles.image}>
              <Link to={'/info/' + movie.id}>
                <img
                  src={movie.poster_path}
                  key={movie.id}
                  alt="Movie Poster"
                />
              </Link>
            </div>
            <div className={styles.info}>
              <h3 key={movie.id}>{movie.title}</h3>
            </div>
          </div>
        ))}
      </div>
      <Footer />
    </Fragment>
  );
};

export default Movies;
